import React from "react";
import { useNavigate } from "react-router-dom";
import "./SRCard.css";

const SellSrCard = ({ data, UserId }) => {

  const navigate = useNavigate();

  return (
    <>
      <div className="fredCard">
        <div className="border rounded p-3">
          <div
            className="d-flex align-items-center mb-3 pb-3"
            style={{
              justifyContent: "space-between",
              borderBottom: "1px solid #cecece",
            }}
          >
            <div className="d-flex align-items-center">
              <h6 className="ms-2 mb-0">{data?.name}</h6>
            </div>
            {/* <button className="buyButton btn btn-primary btn-sm ms-auto mt-2">
              SR
            </button> */}
          </div>
          <figure
            className="tranding-img rounded position-relative text-center p-2"
            style={{
              background: `url(${data?.image})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              height: "200px",
            }}
          ></figure>
          <div className="card-details">
            {/* <div>
              <h6 className="fw-bold">{data?.name}</h6>
            </div> */}
            <div className="d-flex">
              <span className="fw-500">Symbol </span>
              <span className="text-uppercase text-success ms-auto">
                {data?.symbol}
              </span>
            </div>
            <div className="d-flex">
              <span className="fw-500">Price </span>
              <span className="text-uppercase text-success ms-auto">
                {Number(data?.balance).toLocaleString()} RED
              </span>
            </div>
            <div className="d-flex">
              <span className="fw-500">Quantity </span>
              <span className="text-uppercase text-success ms-auto">
                {Number(data?.quantity / 10 ** 18).toLocaleString()}
              </span>
            </div>
          </div>

          <div className="d-flex">
            <button
              className="buyButton btn btn-primary btn-sm ms-auto mt-2"
              onClick={() =>
                navigate("/user-marketplace-sr-details", {
                  state: { data: data, UserId: UserId },
                })
              }
            >
              View Detail
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellSrCard;
